import { StyleSheet, Dimensions } from 'react-native';

export default StyleSheet.create({
    background: {
        flex: 1,
        overflow: 'hidden',
        height: '100%',
        width: '100%',
        position: 'fixed',
        zIndex: 100000
    },
    imageContainer: {
        flex: 4,
        justifyContent: 'center',
        alignItems: 'center'
    },
    image: {
        flex: 1,
        width: Dimensions.get('screen').width - 20,
        resizeMode: 'contain'
    },
    contentContainer: {
        flex: 2,
        paddingHorizontal: 30,
        maxHeight: 600,
        justifyContent: 'center'
    },
    titleContainer: {
        flex: 1,
        justifyContent: 'flex-end'
    },
    title: {
        color: 'white',
        fontSize: '3vh',
        fontWeight: '200',
        textAlign: 'center'
    },
    descriptionContainer: {
        flex: 1,
        padding: 20
    },
    description: {
        fontSize: '2vh',
        fontWeight: '100',
        color: '#A4A4A4',
        textAlign: 'center'
    },
    storeButtonsContainer: {
        flex: 3,
        maxWidth: 400,
        flexDirection: 'row',
        alignSelf: 'center',
        justifyContent: 'space-between',
        width: '100%'
    },
    storeImageContainer: {
        alignItems: 'center',
        marginHorizontal: 10,
        flexGrow: 1
    },
    storeImage: {
        flex: 1,
        resizeMode: 'contain',
        width: '100%'
    },
    linkToDesktop: {
        borderBottomWidth: 1,
        borderBottomColor: 'white',
        color: 'white',
        fontSize: 32
    }
});
